import { ProductDoc, ProductSnapshotDoc } from '@gooduncles/gu-app-schema';
import useSWRImmutable from 'swr/immutable';

import { promiseAllSettled } from 'src/utils/common';
import { getDaysForMonths } from 'src/utils/date-util';
import { getProductSnapshot } from 'src/utils/firebase/firebase-short-cut';

const getProductSnapshotsForId = async (productId: ProductDoc['_id'], monthRange = 3) => {
  const days = getDaysForMonths(monthRange);
  const promises = days.map((day) => getProductSnapshot(`${day}-${productId}`));
  const result = await promiseAllSettled(promises);
  return result.fulfilled.filter((item) => item) as ProductSnapshotDoc[];
};

const useProductSnapshotsForId = (id?: ProductDoc['_id']) => {
  const {
    data,
    isValidating: snapshotsLoading,
    error: snapshotsError,
  } = useSWRImmutable(id ? id : null, getProductSnapshotsForId, {
    errorRetryCount: 2,
  });

  return {
    snapshots: data,
    snapshotsLoading,
    snapshotsError,
  };
};

export default useProductSnapshotsForId;
